var ProfileInfoView = require('../shared/app/views/components/profile-info.js');
var RegisterClientModel = require('../models/client');

var Login = Backbone.Epoxy.View.extend({

  template: 'login',
  bindings: 'data-bind',

  events: {
    'click #loginButton': 'login',
    'click #logoutButton': 'logout',
    'click .forgot-password-link': 'showPasswordRecovery',
    'click #registerButton' : 'showConfirmModal',
    'focusout #emailRegister, #confirmationFirstName, #confirmationLastName, #confirmationPhone': 'checkUser',
    'focus .form-control': function(e) { this.$(e.target).select(); },
    'click #toRegister': function(e) { bookedby.app.navigateTo('login', { tab:'register' }); },
    'click #toLogin': function(e) { bookedby.app.navigateTo('login', { tab:'login' }); }
  },

  bindingSources : {
    loginModel : new Backbone.Epoxy.Model({
      'showLogin': true,
      'hasMessage': false,
      message: '',
      isSuccess: false,
      isLoading: false,
      registerOnly: false
    })
  },

  initialize: function() {
    this.hasRendered = false;
    this.model = bookedby.app.getCurrentClient();
    this.registerClientModel = new RegisterClientModel();

    if (bookedby.staticData.storeGroupSettings.reduceClientNeededInfo) {
      this.model.set('useFullName', true);
    }
  },

  showPasswordRecovery: function() {
    //var email = this.$el.find('.email-form').val();
    bookedby.app.passwordRecoveryForm.show(this.model.get('email'));
  },

  login: function () {
    global.bookedby.helpers.loginEvent();

    this.clearMessages();
    //var email = this.$el.find('.email-form').val();
    //var password = this.$el.find('.password-form').val();

    this.model.set('isGuest', false);
    this.model.isValid(true);

    if(!this.model.isValid(['email'])){
      this.$el.find('#emailLogin').attr('aria-invalid', true);
    } else {
      this.$el.find('#emailLogin').attr('aria-invalid', false);
    }

    if(!this.model.isValid(['password'])){
      this.$el.find('#passwordLogin').attr('aria-invalid', true);
    } else {
      this.$el.find('#passwordLogin').attr('aria-invalid', false);
    }

    if(!this.model.isValid(['email', 'password']))
      return;

    this.bindingSources.loginModel.set('isLoading', true);
    bookedby.app.loginClient(this.model.get('email'), this.model.get('password'), _.bind(this.onLoginSuccess, this), _.bind(this.onLoginFail, this));
  },

  logout: function () {
    this.clearMessages();
    this.model.set('hasMessage', false);
    this.model.set('message', '');
    bookedby.app.logOut();
  },

  refresh: function() {
    this.clearMessages();
  },

  checkUser: function() {
    bookedby.app.startLoading();
    var deferred = $.Deferred();
    bookedby.app.checkCurrentClient(_.bind(function(data) {
      bookedby.app.finishLoading();
      var clientModel = bookedby.app.getCurrentClient();
      this.bindingSources.loginModel.set('hasMessage', true);

      var options = {
        message: '',
        cancelLabel: 'No',
        confirmLabel: 'Yes',
        showCancelLabel: true
      };

      if(data.email == clientModel.get('email')) {
        //this.bindingSources.loginModel.set('message', 'A user with that email already exists. Please login instead.');
        options.message = 'A user with that email already exists. Would you like to login instead?'
      } else {
        //this.bindingSources.loginModel.set('message', 'A user with the same data already exists. Please login instead.');
        options.message = 'A user with the same data already exists. Would you like to login instead?'
      }

      deferred.reject();

      bookedby.app.confirmForm.show(_.bind(function(){
        bookedby.app.navigateTo('login', { tab:'login' });
      }, this), function() {}, options);

      //bookedby.app.navigateTo('login', { tab:'login' });
    }, this), this.registerClientModel, function() { bookedby.app.finishLoading(); deferred.resolve(); } );
    return deferred;
  },

  showRegisterForm: function () {
    this.bindingSources.loginModel.set('showLogin', false);
  },

  showLoginForm: function () {
    this.bindingSources.loginModel.set('showLogin', true);
  },

  clearMessages: function() {
    this.bindingSources.loginModel.set('hasMessage', false);
    this.bindingSources.loginModel.set('message', '');
    this.model.set('validationSuspended', true);
  },

  onLoginSuccess: function(data) {
    // bookedby.app.currentClient = this.registerClientModel;
    this.bindingSources.loginModel.set('isLoading', false);
    if (bookedby.app.section == "main") {
      bookedby.app.navigateAfterAuthenticated('profile', {});
    }else {
      bookedby.app.navigateToIntended();
    }
  },

  onLoginFail: function(data) {
    this.bindingSources.loginModel.set('isLoading', false);
    //TODO:: better error display...
    if (data.success && !data.found) {
      //TODO:: login failed message
      alert('Login failed.');
    }
    if (!data.success) {
      if (data.userError) {
        //alert(data.error);

        this.bindingSources.loginModel.set('hasMessage', true);
        this.bindingSources.loginModel.set('message', data.error);
      } else {
        alert('There was a problem processing your request. Please try again in a few minutes.');
      }
    }
  },

  setData: function (data) {
    this.bindingSources.loginModel.set('registerOnly', false);
    this.model.clearValidation();

    if (data.tab) {
      if (data.tab == 'login') {
        this.$el.find('.email-form').val(bookedby.app.getCurrentClient().get('email'));
        this.$el.find('.password-form').val(bookedby.app.getCurrentClient().get('password'));
        this.bindingSources.loginModel.set('showLogin', true);
      } else if (data.tab == 'register') {
        //bookedby.app.getCurrentClient().set('email', this.$el.find('.email-form').val()); //TODO recheck original intent
        //bookedby.app.getCurrentClient().set('password', this.$el.find('.password-form').val()); //TODO recheck original intent
        this.bindingSources.loginModel.set('showLogin', false);
      } else {
        bookedby.app.getCurrentClient().set('email', this.$el.find('.email-form').val());
        bookedby.app.getCurrentClient().set('password', this.$el.find('.password-form').val());
        this.bindingSources.loginModel.set('showLogin', false);
      }
    } else {
      if (data.onlyRegister) {
        this.bindingSources.loginModel.set('showLogin', false);
        this.bindingSources.loginModel.set('registerOnly', true);
      } else {
        this.$el.find('.email-form').val(bookedby.app.getCurrentClient().get('email'));
        this.$el.find('.password-form').val(bookedby.app.getCurrentClient().get('password'));
        this.bindingSources.loginModel.set('showLogin', true);
      }
    }

    if (data.message != null) {
      this.bindingSources.loginModel.set('hasMessage', true);
      this.bindingSources.loginModel.set('message', data.message);
    } else {
      this.bindingSources.loginModel.set('hasMessage', false);
      this.bindingSources.loginModel.set('message', '');
    }

    if (data.recover && bookedby.app.getCurrentClient().get('email') != null) {
      this.bindingSources.loginModel.set('isSuccess', true);
      this.fromRecovery = true;
    } else {
      this.fromRecovery = false;
    }
  },

  sendConfirmationCode: function (confirmationType, client) {
    var deferred = $.Deferred();

    var clientData = client.getConfirmationClientData();

    bookedby.app.sendConfirmation(confirmationType, clientData)
    .then(_.bind(function(response) {
      client.set({
        sendConfirmCodeError: false
      });
      if (response.success) {
        deferred.resolve()
      } else {
        if (response.errCode === 400) {
          client.set({
            sendConfirmCodeError: true,
            sendConfirmCodeErrorMessage: response.clientValidationErrors
          });
          deferred.reject();
        } else if (response.userError){
          client.set({
            sendConfirmCodeError:true,
            sendConfirmCodeErrorMessage: response.error
          });
          deferred.reject();
          if (response.errCode == 'emailIsRegistered'){
            bookedby.app.confirmForm.show(_.bind(function() {
              bookedby.app.navigateTo('login', { tab:'login' });
            }, this), _.noop, {
              message: response.error,
              cancelLabel: 'Cancel',
              confirmLabel: 'Login',
              showCancelLabel: true
            });
          }
        } else {
          bookedby.app.confirmForm.show(_.bind(function() {
            this.sendConfirmationCode(confirmationType, client).then(deferred.resolve, deferred.reject);
          }, this), deferred.reject, {
            message: 'There was error sending confirmation code',
            cancelLabel: 'Cancel',
            confirmLabel: 'Try again',
            showCancelLabel: true
          });
        }
      }
    }, this));

    return deferred;
  },

  showConfirmModal: function() {
    
    global.bookedby.helpers.registerEvent();
    var currentClientModel = this.registerClientModel;
    currentClientModel.parseFullName();
        
    if (currentClientModel.isValid(true)) {
        this.checkUser().then(_.bind(function(){
          var options = {
            confirmLabel: 'Got It',
            showCancelLabel: false,
            title: "Registration confirmation succesfully sent",
            allowClose: false
          };

          var _sendConfirmation = _.bind(
            function(confirmationType, confirmationMessage, finishLoading){
              this.sendConfirmationCode(confirmationType, currentClientModel).then(_.bind(function() {
                finishLoading();
                options.message = confirmationMessage;
                bookedby.app.confirmForm.show(function() {bookedby.app.navigateTo('start-wait-list');}, _.bind(this.render, this), options);
              }, this));
            }
            ,this);

            if (bookedby.staticData.storeGroupSettings.disableRegistrationConfirmationSms){
              bookedby.app.startLoading();
              _sendConfirmation("Email", "Please check your mailbox for confirmation email and use the link inside to finish your registration and check-in", 
                function(){ bookedby.app.finishLoading();});
            } else {
              bookedby.app.confirmForm.show(
                function(finishLoading) {
                  //Email Chosen
                  _sendConfirmation("Email", "Please check your mailbox for confirmation email and use the link inside to finish your registration", finishLoading);
                }, 
                function(finishLoading) {
                  //SMS chosen
                  _sendConfirmation("SMS", "Please check your phone for new SMS and use the link inside to finish your registration", finishLoading);
                },
              {
                title: 'ACCOUNT VERIFICATION',
                message: 'In order to secure your account, we will send you a verification link to your preferred method below',
                cancelLabel: 'BY SMS',
                confirmLabel: 'BY EMAIL',
                loadingLabel: 'Emailing...',
                cancellingLabel: 'Sending SMS...',
                showCancelLabel: true,
                allowClose: true,
                showContactUs: bookedby.staticData.storeGroupSettings.isSCMode,
                useSameButtons: true,
                useLoading: true
              });
          }
      },this));
    }
  },

  beforeRender: function() {
    this.registerClientModel.set(this.registerClientModel.defaults);

    this.model.set('skipPasswordValidation', true);
    this.registerClientModel.set('skipPasswordValidation', true);
    this.setView('.profile-info-area', new ProfileInfoView({
      model: this.registerClientModel,
      showPasswordFields: false
    }));

    if (!this.eventsReady) {
      this.eventsReady = true;
    }

    if (this.hasRendered) {
      return false;
    }

    this.hasRendered = true;


    return true;
  },

  afterRender: function() {
    if (!this.isLoading) {
      bookedby.app.finishLoading();
    }
    this.applyBindings();

    if (this.fromRecovery) {
      this.$el.find('.email-form').val(bookedby.app.getCurrentClient().get('email'));
      this.$('.password-form').focus();
    }
  },

  cleanup: function() {
    this.removeBindings();

    bookedby.app.currentClient.set('password', null);
    bookedby.app.currentClient.set('passwordConfirm', null);
  }

});

module.exports = Login;
